<div
    [ngClass]="{
        'side-nav-tool-tip': tooltipType === 'sidenav',
        'main-page-tool-tip': tooltipType === 'mainPage',
        'mathia-workspaces': tooltipType === 'mathiaWorkspace'
    }"
  [ngStyle]="{ top: top, left: left }"
  >
  @if (text) {
    <div aria-hidden="true">{{ text }}</div>
  }
  @if (progressStatus && completeDate && timeSpent) {
    <span
      class="progress-tool-tip-container"
      [ngStyle]="{ top, left }"
      aria-hidden="true"
      >
      <div></div>
      <div>
        <span [style.font-weight]="'bold'">Completed: </span>
        <span class="date-completed">{{ completeDate }}</span>
      </div>
      <div>
        <span [style.font-weight]="'bold'">Time Spent: </span>
        <span class="time-spent">{{ timeSpent }}</span>
      </div>
    </span>
  }
</div>
